






























import Card from '@/components/Card.vue';
import { Study, uniqueId } from 'common';
import { setVue, makeRequest } from '@/utils';
import { ref, createComponent } from '@vue/composition-api';

export default createComponent({
  name: 'StudyCard',
  components: { Card },
  props: {
    study: {
      type: Object as () => Study,
      required: true,
    },
  },
  setup(props, context) {
    const searchModel = ref('');

    const close = () => {
      context.emit('close');
    };

    const deleteStudy = () => {
      context.emit('delete');
    };

    const setLabel = (label: string) => {
      setVue(props.study, 'label', label);
      context.emit('update');
    };

    const setSource = (source: string) => {
      setVue(props.study, 'source', source);
      context.emit('update');
    };

    const setSignalingPathway = (signalingPathway: string) => {
      setVue(props.study, 'signalingPathway', signalingPathway);
      context.emit('update');
    };

    return {
      deleteStudy,
      setSignalingPathway,
      searchModel,
      setSource,
      setLabel,
      close,
    };
  },
});
